

























































































































































































































































































































































































































































































































	import {
		PullRefresh,
		Overlay,
		Toast,
		Popup,
		List,
		Picker,
		Checkbox,
		CheckboxGroup,
		ActionSheet,
		Field,
		Dialog,
		Button,
		Divider,
		Icon
	} from "vant";
  import { myTransactionSocket } from '@/views/h5-page/mixins/myTransactionSocket';
  import * as Sentry from "@sentry/vue";
  import bus from "@/utils/bus";

	export default {
    mixins: [myTransactionSocket],
		components: {
			[Overlay.name]: Overlay,
			[PullRefresh.name]: PullRefresh,
			[Popup.name]: Popup,
			[Picker.name]: Picker,
			[List.name]: List,
			[ActionSheet.name]: ActionSheet,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
			[Field.name]: Field,
			[Button.name]: Button,
			[Divider.name]: Divider,
			[Icon.name]: Icon
		},
		props: {
			queryParem: {
				type: Object,
				default: {}
			},
			activeTab: {
				type: Number,
				default: 0
			},
			isSecurities: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
        hasAcution: ["HSI", "MHI", "HHI", "MCH"],
				overlayShow: false,
				refreshing: false,
				loading: false,
				finished: false,
				list: [],
				groupColumns: ['全部'],
				popupShow: false,
				// 49 市价 50 限价 71 港交所竞价市价单 72 港交所竞价限价单
				curOrderType: '限价单',
				curOrderIndex: true,
				typeColumns: ['限价单'],
				typeValue: ['50', '49', '71', '72'],
				typePopupShow: false,
				checked: false,
				activeIcon: require('@/assets/images/h5Page/checked.png'),
				inactiveIcon: require('@/assets/images/h5Page/noCheck.png'),
				halfSelected: require('@/assets/images/h5Page/half-selected.png'),
				accountAll: [],
				sheetShow: false,
				sheetForm: {
					number: '',
					checked: false,
					order_price: '',
					priceType: 1
				},
				positionForm: {
					number: 1,
					checked: false,
					order_type: '50',
					priceType: 1
				},
				curPriceType: '最新价',
				submitType: 1,

				tableData: [],
				// initTableData: [],
				sonTableData: [],
				totalNum: 0,
				sonTotalNum: 0,
				listParem: {
					page: 0,
					size: 1000,
					account_nos: (this as any).queryParem.account || ''
				},
				sonParem: {
					page: 0,
					size: 1000,
					symbol: '',
					is_close: 1,
					account_nos: (this as any).queryParem.account || ''
				},
				sonLoading: false,
				sonFinished: false,
				isHalfSelected: false,
				rowPosition: {},
				symbolList: [],
				batchGoods: '',
				queryTable: [],
				noPriceList: [],
				curSelectList: [],
				noPriceTypeList: [],
				curSelectPriceList: [],
				curRateMsg: null,
				contract_info_msg: null,
				marketType: 1,
				initReq: true,
				isScroll: false,
				issSonScroll: false,
				exchangeList: [],

				priceShow: true,
				delPng: require('@/assets/images/h5Page/del_d.png'),
				adPng: require('@/assets/images/h5Page/add_d.png'),
				adPrPng: require('@/assets/images/h5Page/add_d.png'),
				delPrPng: require('@/assets/images/h5Page/del_d.png'),
				numberClick: false,
				priceClick: false,
				isFocse: false,
				selectAllData: {},
				isChecked: false,
        tableMouseObj: {
          isDragging: false,
          startX: 0,
          startScrollLeft: 0
        },
        sonTableMouseObj: {
          isDragging: false,
          startX: 0,
          startScrollLeft: 0
        },
		mPositionTypeList: [
			{text: '全部', value: 1},
			{text: '1/2', value: 0.5},
			{text: '1/4', value: 0.25},
		],
		mPositionTypeActive: 1,
		mPositionIsFocse: false
      };
		},
		computed: {
			sheetFormDis() {
				const {
					order_price,
					number
				} = (this as any).sheetForm;
				if (+order_price && +number && +number > 0) {
					if (+number > +(this as any).rowPosition.can_close_num) {
						return true
					}
					return false
				} else {
					return true
				}
			},
		},
		watch: {
			queryParem: {
				handler(val) {
					(this as any).listParem.account_nos = val.account || '';
					(this as any).sonParem.account_nos = val.account || '';
					// (this as any).curOrderType = '限价单';
					// if(val.type === 1){
					//     (this as any).typeColumns = ['限价单'];
					//     (this as any).typeValue = ['50'];
					// }else if(val.type === 2){
					//     (this as any).typeColumns = ['限价单','市价单','竞价市价单','竞价限价单'];
					//     (this as any).typeValue = ['50','49','71','72'];
					// }

					if(val.account){
						clearTimeout((this as any).timer)
						if ((this as any).activeTab === 0) {
							(this as any).refreshing = true;
							(this as any).onRefresh();
						}
					}


				},
				deep: true
			},
			marketType: {
				handler(val) {
					(this as any).curOrderType = '限价单';
					if (val === 1) {
						(this as any).typeColumns = ['限价单'];
						(this as any).typeValue = ['50'];
					} else if (val === 2) {
						(this as any).typeColumns = ['限价单', '市价单', '竞价市价单', '竞价限价单'];
						(this as any).typeValue = ['50', '49', '71', '72'];
					} else if (val === 3) {
						(this as any).typeColumns = ['限价单', '市价单'];
						(this as any).typeValue = ['50', '49'];
					} else if (val === 4) {
						(this as any).typeColumns = ['限价单', '市价单'];
						(this as any).typeValue = ['50', '49'];
					}
          else if(val == 5){
            (this as any).typeColumns = ['限价单', '竞价市价单'];
            (this as any).typeValue = ['50', '66'];
          }
				},
			},
			activeTab: {
				handler(val) {
          clearTimeout((this as any).timer);
          clearTimeout((this as any).sonTimer);
					if (val === 0) {
						(this as any).refreshing = true;
						(this as any).onRefresh();
            (this as any).isLockWs = false;
					}else{
            (this as any).$socket.stop();
            (this as any).isLockWs = true;
          }
				},
				deep: true
			}
		},
		filters: {
			priceStatus(val) {
				let str = ''
				if (!val) {
					str = ''
				} else if (val > 0) {
					str = 'color: #EB3323;'
				} else {
					str = 'color: #02AA39;'
				}
				return str
			},
			canCloseNum(val) {}
		},
		async created() {
      (this as any).wsBaseURLListIndex = 0;
			(this as any).listParem.account_nos = (this as any).queryParem.account || '';
			(this as any).sonParem.account_nos = (this as any).queryParem.account || '';
			// if((this as any).queryParem.type === 1){
			//     (this as any).typeColumns = ['限价单'];
			//     (this as any).typeValue = ['50'];
			// }else if((this as any).queryParem.type === 2){
			//     (this as any).typeColumns = ['限价单','市价单','竞价市价单','竞价限价单'];
			//     (this as any).typeValue = ['50','49','71','72'];
			// }

			// await (this as any).onLoad();

			// openWebSocket();
			let exchangeObj: any = localStorage.getItem('exchangeList');
			(this as any).exchangeList = JSON.parse(exchangeObj);
			if (!(this as any).$route.meta.isH5Login) {
				Toast.setDefaultOptions({
					duration: 1500,
					closeOnClickOverlay: true,
					overlay: true
				});
			} else {
				Toast.resetDefaultOptions();
			}
		},
    mounted() {
      const _window = (window as any);
      const _this = (this as any);
      _this.visibilityFn = (e) => {
        if(e.target.visibilityState == 'hidden'){
          clearTimeout(_this.timer);
          clearTimeout(_this.sonTimer);
          _this.isLockWs = true;
        }else{
          if ((this as any).activeTab === 0) {
            clearTimeout(_this.timer);
            clearTimeout(_this.sonTimer);
            _this.isLockWs = false;
            _this.onRefresh();
          }
        }
      };
      _window.addEventListener('visibilitychange', _this.visibilityFn);
      bus.$on("transactionOnMsg", _ => {
          if(!_this.isLockWs){
            _this.mySocketOnMsg();
          }
      })
      bus.$on("onmessage", msg => {
        if(!_this.isLockWs && (msg.last_price || msg.pre_closing_price || msg.pre_settle_price)){
          if ((this as any).tableData.length !== 0) {
            (this as any).tableData.forEach(item => {
              if (item.symbol === msg.symbol) {
                if (!msg.last_price && !msg.pre_closing_price) {
                  item.quote_price = msg.pre_settle_price
                } else if (!msg.last_price && !msg.pre_settle_price) {
                  item.quote_price = msg.pre_closing_price
                } else if (!msg.pre_closing_price && !msg.pre_settle_price) {
                  item.quote_price = msg.last_price
                } else {
                  item.quote_price = msg.last_price
                }
                item.date_time_stamp = msg.date_time_stamp;
                if ((this as any).queryParem.type === 1) {
                  item.profitLoss = +(((item.quote_price - item.position_price) * item
                    .position * item.rateNum * item.contract_size).toFixed(2));
                  // 浮动盈亏 / 成本）* 100%
                  item.profitLossRate = item.cost ? (item.profitLoss / item.cost) * 100 :
                    100;
                } else if ((this as any).queryParem.type === 2) {
                  item.profitLoss = +(((item.quote_price - item.position_price) * item
                    .position_qty).toFixed(2));
                  item.profitLossRate = item.cost ? (item.profitLoss / item.cost) * 100 :
                    100;
                }

                if (item.match_side === 66) {
                  item.counterpartyPrice = (msg.bid_price && msg.bid_price[0]) || null; //对手价
                  item.queuingPrice = (msg.ask_price && msg.ask_price[0]) || null; //排队价
                } else if (item.match_side === 83) {
                  item.counterpartyPrice = (msg.ask_price && msg.ask_price[0]) || null; //对手价
                  item.queuingPrice = (msg.bid_price && msg.bid_price[0]) || null; //排队价
                }

                if ((this as any).rowPosition.symbol === msg.symbol) {
                  if (item.account_no === (this as any).rowPosition.account_no) {
                    (this as any).rowPosition = JSON.parse(JSON.stringify(item));
                    (this as any).orderPrice(item)
                  }
                  (this as any).delPrPng = require('@/assets/images/h5Page/del.png');

                }

              }
            })
          }

          if ((this as any).sonTableData) {
            (this as any).sonTableData.forEach(item => {
              if (item.symbol === msg.symbol) {
                if (!msg.last_price && !msg.pre_closing_price) {
                  item.quote_price = msg.pre_settle_price
                } else if (!msg.last_price && !msg.pre_settle_price) {
                  item.quote_price = msg.pre_closing_price
                } else if (!msg.pre_closing_price && !msg.pre_settle_price) {
                  item.quote_price = msg.last_price
                } else {
                  item.quote_price = msg.last_price
                }
                item.date_time_stamp = msg.date_time_stamp;
                // item.currentPrice = msg.last_price
                item.profitLossRate = item.cost ? (item.profitLoss / item.cost) * 100 : 100;
                item.profitLoss = +(((item.quote_price - item.position_price) * item
                  .position_qty).toFixed(2));
                if (item.match_side === 66) {
                  item.counterpartyPrice = msg.bid_price[0]; //对手价
                  // item.currentPrice = msg.bid_price[0];
                  item.queuingPrice = msg.ask_price[0]; //排队价
                  if ((this as any).positionForm.priceType === 1) {
                    item.currentPrice = msg.last_price
                  } else if ((this as any).positionForm.priceType === 2) {
                    item.currentPrice = msg.ask_price[0]
                  } else if ((this as any).positionForm.priceType === 3) {
                    item.currentPrice = msg.bid_price[0]
                  }


                } else if (item.match_side === 83) {
                  item.counterpartyPrice = msg.ask_price[0]; //对手价
                  // item.currentPrice = msg.ask_price[0];
                  item.queuingPrice = msg.bid_price[0]; //排队价
                  if ((this as any).positionForm.priceType === 1) {
                    item.currentPrice = msg.last_price
                  } else if ((this as any).positionForm.priceType === 2) {
                    item.currentPrice = msg.bid_price[0]
                  } else if ((this as any).positionForm.priceType === 3) {
                    item.currentPrice = msg.ask_price[0]
                  }
                }

              }
            })
          }
        }

      });
    },
    methods: {
			// 单个平仓 数量 切换
			changeMPositionType(type){
				if(type !=  '-1'){
					let _this = (this as any);
          _this.mPositionTypeActive = type;
          const { commodity_type, lot_min } = _this.rowPosition;
          
          if(commodity_type == 70){
            // 期货
            _this.sheetForm.number = Math.ceil(_this.rowPosition.can_close_num * _this.mPositionTypeActive);
          }
          else if (commodity_type == 84){
            // 证券
            _this.sheetForm.number = Math.ceil(_this.rowPosition.can_close_num * _this.mPositionTypeActive / lot_min) * lot_min;
          }

				}
			},

			overlayShowHandler() {
				(this as any).overlayShow = !(this as any).overlayShow;
				// (this as any).getSonListNew();
			},
			// 数量增加
			handNumberAdd(e) {
				e.stopPropagation();
				if ((this as any).rowPosition.symbol) {
					(this as any).sheetForm.number = Number((this as any).sheetForm.number) + Number((this as any)
						.rowPosition.lot_min);
					(this as any).delPng = require('@/assets/images/h5Page/del.png');
					(this as any).numberClick = true;
				}
				//  else if ((this as any).rowPosition.symbol && (this as any).sheetForm.number == 2) {
				//     (this as any).delPng = require('@/assets/images/h5Page/del.png');
				//     (this as any).numberClick = true;
				//     if (!(this as any).sheetForm.number) {
				//         (this as any).sheetForm.number = 0.01;
				//     } else if ((this as any).sheetForm.number < 100) {
				//         (this as any).sheetForm.number = parseFloat((this as any).sheetForm.number) + 0.01;
				//         setTimeout(() => {
				//             if ((this as any).sheetForm.number == 100) {
				//                 (this as any).addPng = require('@/assets/images/h5Page/add_d.png');
				//                 (this as any).sheetForm.number = 100;
				//             }
				//         }, 200)
				//     } else if ((this as any).sheetForm.number == 100) {
				//         (this as any).addPng = require('@/assets/images/h5Page/add_d.png');
				//         (this as any).sheetForm.number = 100;
				//     }
				// }
				(this as any).inputSheetFormNumber();
				(this as any).mPositionTypeActive = -1;

			},
			// 数量 输入了内容
			inputSheetFormNumber(e){
				(this as any).isInputSheetFormNumber = true;

			},
			// 数量减
			handNumberDel() {
				if ((this as any).numberClick) {
					if (Number((this as any).sheetForm.number) != Number((this as any).rowPosition.lot_min)) {
						(this as any).delPng = require('@/assets/images/h5Page/del.png');
						(this as any).sheetForm.number = Number((this as any).sheetForm.number) - Number((this as any)
							.rowPosition.lot_min);
						// setTimeout(() => {
						// 	// (this as any).handNumberChange();
						// }, 200)
					}
					setTimeout(() => {
						if (Number((this as any).sheetForm.number) == Number((this as any).rowPosition.lot_min)) {
							(this as any).delPng = require('@/assets/images/h5Page/del_d.png');
							(this as any).numberClick = false;
						}
					}, 200);
					(this as any).inputSheetFormNumber();
					(this as any).mPositionTypeActive = -1;
				}
				// else if ((this as any).rowPosition.symbol && (this as any).sheetForm.number == 2 && (this as any).numberClick) {
				//     if (!(this as any).sheetForm.number) {
				//         (this as any).sheetForm.number = 0;
				//     } else if ((this as any).sheetForm.number < 100 && (this as any).sheetForm.number > 0) {
				//         (this as any).sheetForm.number = parseFloat((this as any).sheetForm.number) - 0.01;
				//         setTimeout(() => {
				//             if ((this as any).sheetForm.number == 0) {
				//                 (this as any).delPng = require('@/assets/images/h5Page/del_d.png');
				//                 (this as any).sheetForm.number = 0;
				//                 (this as any).numberClick = false;
				//             }
				//         }, 200)
				//     } else if ((this as any).sheetForm.number == 0) {
				//         (this as any).addPrPng = require('@/assets/images/h5Page/del_d.png');
				//         (this as any).sheetForm.number = 0;
				//         (this as any).numberClick = false;
				//     }
				// }
			},
			// 价格加
			handPriceAdd() {
				if ((this as any).rowPosition.symbol) {
					(this as any).isFocse = true;
					(this as any).sheetForm.priceType = 0;
					let exchangeCode: any = [];
					let price = '';
					(this as any).$apis.querychangeunit().then(respond => {
						let res = {
							data: respond
						}
						res.data.infos.forEach(item => {
							exchangeCode.push(item.exchangeCode);
						});
						if (exchangeCode.findIndex(item => item === (this as any).rowPosition.exchange_no) > -1) {
							res.data.infos.forEach(item => {
								if (item.exchangeCode === (this as any).rowPosition.exchange_no) {
									item.rules.forEach(item1 => {
										if ((parseFloat((this as any).sheetForm.order_price) >
												item1.begin ||
												parseFloat((this as any).sheetForm.order_price) ==
												item1.begin
											) && (parseFloat((this as any).sheetForm.order_price) <
												item1
												.end || parseFloat((this as any).sheetForm
													.order_price) == item1
												.end)) {
											price = item1.changeUnit
										}
									})
								}
							})
						} else {
							price = (this as any).rowPosition.commodity_tick_size
						}
						if (!(this as any).sheetForm.order_price) {
							(this as any).sheetForm.order_price = 0
						}
						let x = String(price).indexOf('.') + 1
						let y = String(price).length - x
						if (x == 0) {
							// 
							(this as any).sheetForm.order_price = (parseFloat((this as any).sheetForm
									.order_price) + parseFloat(price))
								.toFixed(x);
							(this as any).delPrPng = require('@/assets/images/h5Page/del.png');
							(this as any).priceClick = true;
						} else if (y > 0) {
							// 
							(this as any).sheetForm.order_price = (parseFloat((this as any).sheetForm
									.order_price) + parseFloat(price))
								.toFixed(y);
							(this as any).delPrPng = require('@/assets/images/h5Page/del.png');
							(this as any).priceClick = true;
						}
					})
				}
			},
			// 价格减
			handPriceDel() {
				if ((this as any).rowPosition.symbol && (this as any).priceClick && (this as any).sheetForm.order_price) {
					(this as any).isFocse = true;
					(this as any).sheetForm.priceType = 0;
					let exchangeCode: any = [];
					let price = '';
					(this as any).$apis.querychangeunit().then(respond => {
						let res = {
							data: respond
						}
						res.data.infos.forEach(item => {
							exchangeCode.push(item.exchangeCode);
						})
						if (exchangeCode.findIndex(item => item === (this as any).rowPosition.exchange_no) > -1) {
							res.data.infos.forEach(item => {
								if (item.exchangeCode === (this as any).rowPosition.exchange_no) {
									item.rules.forEach(item1 => {
										if ((parseFloat((this as any).sheetForm.order_price) >
												item1.begin ||
												parseFloat((this as any).sheetForm.order_price) ==
												item1.begin
											) && (parseFloat((this as any).sheetForm.order_price) <
												item1
												.end || parseFloat((this as any).sheetForm
													.order_price) == item1
												.end)) {
											price = item1.changeUnit
										}
									})
								}
							})
						} else {
							price = (this as any).rowPosition.commodity_tick_size;
						}

						if (!(this as any).sheetForm.order_price) {
							(this as any).sheetForm.order_price = 0;
						}

						let x = String(price).indexOf('.') + 1;
						let y = String(price).length - x;

						if (parseFloat((this as any).sheetForm.order_price) != parseFloat(price) && parseFloat((
								this as any).sheetForm.order_price) > parseFloat(price)) {
							if (x == 0) {
								// 
								(this as any).sheetForm.order_price = (parseFloat((this as any).sheetForm
										.order_price) - parseFloat(price))
									.toFixed(x);
							} else if (y > 0) {
								// 
								(this as any).sheetForm.order_price = (parseFloat((this as any).sheetForm
										.order_price) - parseFloat(price))
									.toFixed(y);
							}
							// setTimeout(() => {
							//     (this as any).handNumberChange();
							// }, 300)
						}
						setTimeout(() => {
							if (parseFloat((this as any).sheetForm.order_price) == parseFloat(price)) {
								(this as any).delPrPng = require('@/assets/images/h5Page/del_d.png');
								(this as any).priceClick = false;
							}
						}, 200)
					})
				}
			},
			sonTableScroll() {
				if ((this as any).$refs['sonTableList'].scrollLeft == 0) {
					//滚动至最左边触发
					(this as any).issSonScroll = false;
				} else {
					(this as any).issSonScroll = true;
				}
			},
			tableScroll(e) {
				if ((this as any).$refs['tableList'].scrollLeft == 0) {
					//滚动至最左边触发
					// 
					(this as any).isScroll = false;
					// (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
					//     item.style.width = 'calc(100vw - '+24+'px)';
					// })
				} else if ((this as any).$refs['tableList'].scrollLeft > ((this as any).$refs['tableList'].scrollWidth - (
						this as any).$refs['tableList'].clientWidth - 10)) {
					//滚动至最右边触发
					// 
					(this as any).isScroll = true;
					// (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
					//     // let num = (this as any).$refs['tableList'].scrollLeft - 40;
					//     item.style.width = 'calc(100% - 24px)';
					// })
				} else {
					//没有任何一边达到顶端
					// 
					(this as any).isScroll = true;
					// (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
					//     let num = (this as any).$refs['tableList'].scrollLeft + (this as any).$refs['tableList'].clientWidth - 45;
					//     item.style.width = ''+num+'px';
					// })
				}

			},
			getTypePrice(quote_price, queuingPrice, counterpartyPrice, symbol_name, index) {
				let obj: any = null;
				switch ((this as any).positionForm.priceType) {
					case 1:
						obj = quote_price;
						(this as any).curPriceType = '最新价';
						break;
					case 2:
						obj = queuingPrice;
						(this as any).curPriceType = '排队价';
						break;
					case 3:
						obj = counterpartyPrice;
						(this as any).curPriceType = '对手价';
						break;
					default:
						break;
				}
				if (!obj) {
					(this as any).noPriceTypeList.push({
						symbol_name,
						index
					})
				}
				return +obj;
			},
			getPrice(quote_price, queuingPrice, counterpartyPrice) {
				let obj: any = null;
				switch ((this as any).positionForm.priceType) {
					case 1:
						obj = quote_price
						break;
					case 2:
						obj = queuingPrice
						break;
					case 3:
						obj = counterpartyPrice
						break;
					default:
						break;
				}
				return +obj;
			},
			/**
			 *
			 * @param lotMin 当前合约信息
			 * @param position 计算之后的数量
			 * @param availableQty 当前持仓数量
			 * @return
			 */
			getOrderNumber(lotMin, can_close_num: any, num: any, availableQty) {
				let d = availableQty;
				let canCloseNum: any = Number(can_close_num);
				let number: any = Number(num);
				let position: any = Math.ceil(canCloseNum / number);
				// position = parseInt(position);
				if (position > availableQty) {
					return availableQty
				}
				if ((this as any).queryParem.type === 2) {
					if (position == 0 || lotMin == 0) {
						return lotMin;
					}
					if (position < lotMin) {
						return lotMin;
					}
					let quotient: any = position / lotMin;
					quotient = parseInt(quotient);
					let left = position % lotMin;
					// // 
					// // 
					// // 
					if (left == 0) {
						return quotient * lotMin;
					}
					let rounding = (quotient + 1) * lotMin;
					if (rounding > availableQty) {
						return position;
					}
					return rounding;
				} else {
					let position: any = Math.ceil(canCloseNum / number);
					// // 
					return position
					// if(position < lotMin){
					//     return lotMin
					// }else{
					//     return position
					// }
				}

			},
			sheetClose() {
				(this as any).sheetShow = false;
				(this as any).$nextTick(()=>{
					(this as any).sheetForm = {
						number: '',
						checked: false,
						order_price: '',
						priceType: 1
					};
					(this as any).isFocse = false;
					(this as any).rowPosition = {};
					(this as any).isInputSheetFormNumber = false;
					(this as any).mPositionTypeActive = 1;
          (this as any).disSubmit = false; //
          (this as any).positionForm = {
            number: 1,
            checked: false,
            order_type: '50',
            priceType: 1
          };
          (this as any).curOrderType = '限价单';
				});

			},
			closeSon() {
				(this as any).groupColumns = ['全部'];
				(this as any).initReq = true;
				(this as any).sonParem = {
					page: 0,
					size: 1000,
					is_close: 1,
					symbol: '',
					account_nos: (this as any).queryParem.account || ''
				};
				(this as any).batchGoods = '';
				(this as any).isHalfSelected = false;
				(this as any).checked = false;
				(this as any).accountAll = [];
				(this as any).selectAllData = {};
				(this as any).overlayShow = false;
				clearTimeout((this as any).sonTimer);
				(this as any).getListNew();
        (this as any).disSubmit = false; //
			},
			openSon() {
				(this as any).positionForm = {
					number: 1,
					checked: false,
					order_type: '50',
					priceType: 1
				};
				(this as any).sonFinished = false;
				(this as any).sonTotalNum = 0;
				(this as any).noPriceList = [];

				(this as any).marketType = 1;
				(this as any).sonParem = {
					page: 0,
					size: 1000,
					is_close: 1,
					symbol: (this as any).sonParem.symbol || '',
					account_nos: (this as any).queryParem.account || ''
				};
				(this as any).sonTableData = [];
				(this as any).onSonLoad();
				setTimeout(() => {
					(this as any).overlayShow = true
				}, 0);
			},
			onSonLoad() {
				// setTimeout(() => {
					// (this as any).sonParem.page++;
					(this as any).getSonListNew();
				// }, 1000);
			},
			async getSonListNew() {
				if ((this as any).overlayShow) {
          await (this as any).getSonList();
          clearTimeout((this as any).timer);
          clearTimeout((this as any).sonTimer);
					if(localStorage.getItem('token')){
            (this as any).sonTimer = setTimeout(() => {
              (this as any).getSonListNew();
            }, 10000)
          }
				}
			},
			async getSonList() {
				// Toast.loading({
				//   duration: 0, // 持续展示 toast
				//   forbidClick: true,
				//   message: '加载中...',
				// });
				(this as any).marketType = 1;
				// (this as any).groupColumns = ['全部'];
				await (this as any).$apis
					.querybatchpos((this as any).sonParem, {
						'X-channel-id': (this as any).queryParem.type
					})
					.then(async (respond) => {
						let res = {
							data: respond
						};
						// Toast('刷新成功');
						(this as any).sonTotalNum = res.data.total;

						let usa = res.data.pos_infos.find(item => {
							if ((item && item.exchange_no) && ['NASDAQ', 'AMEX', 'NYSE'].includes(item.exchange_no)) {
								return item;
							}
						});
						let hk = res.data.pos_infos.find(item => {
							return item.exchange_no === 'HKSE'
						});

						if (hk && usa) {
							(this as any).marketType = 4;
						} else {
							if (hk) {
								(this as any).marketType = 2;
							} else {
								if (usa) {
									(this as any).marketType = 3;
								}
							}
						}

						if ((this as any).initReq) {
							(this as any).symbolList = res.data.symbol_code_names;
							res.data.symbol_code_names && res.data.symbol_code_names.forEach(item => {
								(this as any).groupColumns.push(item.name)
							});
						}

						if (!(this as any).batchGoods) {
							(this as any).batchGoods = (this as any).groupColumns[0];
						};
						(this as any).initReq = false;
						let q = res.data.pos_infos.map(item => {
							return item.symbol
						}).join(',');
						let queryParem: any = {
							page_size: 1000,
							current_page: 1,
							account_no: (this as any).queryParem.account
						};

						if (q) {
							let qute = (this as any).$apis
								.future_ticksnapshot({
									symbol: q
								});
							let rate = (this as any).$apis
								.getRate({
									symbol: q
								});
							let contractInfote = (this as any).$apis
								.getContractInfo({
									symbol: q,
									isExpired: 2
								});
							let getQryFund = (this as any).$apis
								.querygroupfund(queryParem, {
									'X-channel-id': (this as any).queryParem.type
								});
							if ((this as any).queryParem.type === 1) {
								await Promise.all([qute, rate, contractInfote, getQryFund]).then((result1) => {
									(this as any).sonTableData = [];
									let result = result1.map(item => ({
										data: item
									}))
									Toast.clear();
									// 
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										let symbol = result[0].data.future_ticks.find(val => val
											.symbol === item.symbol);
										item.quote_price = item.calculate_price;
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.currentPrice = null; //现价
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										let contract_info = result[2].data.contract_info.find(
											val => val.symbol === item.symbol);
										item.contract_size = contract_info.contract_size ||
										null; //合约乘数
										item.commodity_tick_size = contract_info
											.commodity_tick_size || null; //最小变动单位.
										item.lot_min = contract_info.lot_min || null; //最小交易数量.
										item.digits = contract_info.digits || 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (symbol) {
											item.date_time_stamp = symbol.date_time_stamp;
											let fund = result[3].data.fund_infos.find(val => val
												.account_no === item.account_no);
											if(fund){
												// // 
												let curRate = result[1].data.currency_rate.find(
												val => {
													if (val.to === fund.currency_no && val
														.from === contract_info.currency_no) {
														return val;
													}
												});
												// 当前汇率取值逻辑如下：
												// 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
												// 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
												let rateNum:any = '';
												if(curRate){
													rateNum = item.match_side == 66 ? curRate.sell :
														curRate.buy;
												}else{
													rateNum = 1
												}
												// let rateNum = item.match_side == 66 ? curRate.sell :
												// 	curRate.buy;
												// 仓位 : match_side == 66 ?  position_qty : -position_qty
												let position = item.match_side == 66 ? item
													.position_qty : -item.position_qty;
												item.quote_price = symbol.last_price || symbol
													.pre_closing_price || symbol.pre_settle_price;
												//当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
												item.profitLoss = +(((item.quote_price - item
														.position_price) * position * rateNum *
													contract_info.contract_size).toFixed(2));
												// 浮动盈亏 / 成本）* 100%
												item.profitLossRate = item.cost ? (item.profitLoss /
													item.cost) * 100 : 100;

												if (item.match_side === 66) {
													item.counterpartyPrice = symbol.bid_price[0] &&
														symbol.bid_price[0].toFixed(2);
													item.queuingPrice = symbol.ask_price[0] && symbol
														.ask_price[0].toFixed(2);
												} else if (item.match_side === 83) {
													item.queuingPrice = symbol.bid_price[0] && symbol
														.bid_price[0].toFixed(2);
													item.counterpartyPrice = symbol.ask_price[0] &&
														symbol.ask_price[0].toFixed(2);
												}

												item.rateNum = rateNum;
												item.position = position;
												// item.contract_size = contract_info.contract_size;
											}
										} else {
											let fund = result[3].data.fund_infos.find(val => val
												.account_no === item.account_no);
											if(fund){
												// 
												let curRate = result[1].data.currency_rate.find(
												val => {
													if (val.to === fund.currency_no && val
														.from === contract_info.currency_no) {
														return val;
													}
												});
												// 当前汇率取值逻辑如下：
												// 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
												// 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
												let rateNum:any = '';
												if(curRate){
													rateNum = item.match_side == 66 ? curRate.sell :
														curRate.buy;
												}else{
													rateNum = 1
												}
												// let rateNum = item.match_side == 66 ? curRate.sell :
												// 	curRate.buy;
												// 仓位 : match_side == 66 ?  position_qty : -position_qty
												let position = item.match_side == 66 ? item
													.position_qty : -item.position_qty;
												//当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
												item.profitLoss = +(((item.quote_price - item
														.position_price) * position * rateNum *
													contract_info.contract_size).toFixed(2));
												// 浮动盈亏 / 成本）* 100%
												item.profitLossRate = item.cost ? (item.profitLoss /
													item.cost) * 100 : 100;

												item.rateNum = rateNum;
												item.position = position;
												(this as any).noPriceList.push(item.symbol_name);
											}
										}
										item.currentPrice = (this as any).getTypePrice(item
											.quote_price, item.queuingPrice, item
											.counterpartyPrice, item.symbol_name, index);
										if (!item.currentPrice) {
											if (!(this as any).curSelectPriceList.includes(item
													.symbol_name)) {
												(this as any).curSelectPriceList.push(item
													.symbol_name);
											}
										}
										(this as any).sonTableData.push(item);
									});
									if ((this as any).sonTableData.length >= (this as any).sonTotalNum) {
										(this as any).sonFinished = true;
									};
								}).catch(err => {
									(this as any).sonTableData = [];
									Toast.clear();
									// Toast('接口请求失败');
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										item.currentPrice = (this as any).getTypePrice(item
											.quote_price, item.queuingPrice, item
											.counterpartyPrice, item.symbol_name, index); //现价
										if (!item.currentPrice) {
											if (!(this as any).curSelectPriceList.includes(item
													.symbol_name)) {
												(this as any).curSelectPriceList.push(item
													.symbol_name);
											}
										}
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										(this as any).sonTableData.push(item);
									});
									// // 
									// // 
									if ((this as any).sonTableData.length >= (this as any).sonTotalNum) {
										(this as any).sonFinished = true;
									};
								});
							} else if ((this as any).queryParem.type === 2) {
								// 持仓盈亏（股票）=  （最新价 - 持仓价position_price）* 股数position_qty
								await Promise.all([qute, contractInfote]).then((result1) => {
									(this as any).sonTableData = [];
									let result = result1.map(item => ({
										data: item
									}))

									Toast.clear();
									// // 
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										let symbol = result[0].data.future_ticks.find(val => val
											.symbol === item.symbol);
										// item.currentPrice = null; //现价
										// item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										let contract_info = result[1].data.contract_info.find(
											val => val.symbol === item.symbol);
										item.contract_size = contract_info.contract_size ||
										null; //合约乘数
										item.commodity_tick_size = contract_info
											.commodity_tick_size || null; //最小变动单位.
										item.lot_min = contract_info.lot_min || null; //最小交易数量.
										item.digits = contract_info.digits || 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (symbol) {
											item.date_time_stamp = symbol.date_time_stamp;
											item.quote_price = symbol.last_price || symbol
												.pre_closing_price || symbol.pre_settle_price;
											// （最新价 - 持仓价position_price）* 股数position_qty
											item.profitLoss = +(((item.quote_price - item
													.position_price) * item.position_qty)
												.toFixed(2));
											//证券成本 = 持仓价 * 持仓量position_qty * 合约乘数contract_size * 100%
											let cost = item.position_price * item.position_qty *
												contract_info.contract_size;
											// 浮动盈亏 / 成本）* 100%
											item.profitLossRate = cost ? (item.profitLoss / cost) *
												100 : 100;

											if (item.match_side === 66) {
												item.counterpartyPrice = symbol.bid_price[0] &&
													symbol.bid_price[0].toFixed(2);
												item.queuingPrice = symbol.ask_price[0] && symbol
													.ask_price[0].toFixed(2);
											} else if (item.match_side === 83) {
												item.queuingPrice = symbol.bid_price[0] && symbol
													.bid_price[0].toFixed(2);
												item.counterpartyPrice = symbol.ask_price[0] &&
													symbol.ask_price[0].toFixed(2);
											}
											item.cost = cost; //成本
											// item.contract_size = contract_info.contract_size;
										} else {
											// （最新价 - 持仓价position_price）* 股数position_qty
											item.profitLoss = +(((item.quote_price - item
													.position_price) * item.position_qty)
												.toFixed(2));
											//证券成本 = 持仓价 * 持仓量position_qty * 合约乘数contract_size * 100%
											let cost = item.position_price * item.position_qty *
												contract_info.contract_size;
											// 浮动盈亏 / 成本）* 100%
											item.profitLossRate = cost ? (item.profitLoss / cost) *
												100 : 100;

											item.cost = cost; //成本
											(this as any).noPriceList.push(item.symbol_name);
										}
										item.currentPrice = (this as any).getTypePrice(item
											.quote_price, item.queuingPrice, item
											.counterpartyPrice, item.symbol_name, index);
										if (!item.currentPrice) {
											if (!(this as any).curSelectPriceList.includes(item
													.symbol_name)) {
												(this as any).curSelectPriceList.push(item
													.symbol_name);
											}
										}
										(this as any).sonTableData.push(item);
									});
									if ((this as any).sonTableData.length >= (this as any).sonTotalNum) {
										(this as any).sonFinished = true;
									};
								}).catch(err => {
									(this as any).sonTableData = [];
									Toast.clear();
									// Toast('接口请求失败');
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										item.currentPrice = (this as any).getTypePrice(item
											.quote_price, item.queuingPrice, item
											.counterpartyPrice, item.symbol_name, index); //现价
										if (!item.currentPrice) {
											if (!(this as any).curSelectPriceList.includes(item
													.symbol_name)) {
												(this as any).curSelectPriceList.push(item
													.symbol_name);
											}
										}
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										(this as any).sonTableData.push(item);
									});
									if ((this as any).sonTableData.length >= (this as any).sonTotalNum) {
										(this as any).sonFinished = true;
									};
								});
							}
						} else {
							(this as any).sonTableData = [];
							Toast.clear();
							res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
								item.isgo = false;
								item.quote_price = item.calculate_price; //最新价
								item.profitLoss = null;
								item.profitLossRate = null;
								// item.counterpartyPrice = null; //对手价
								// item.queuingPrice = null; //排队价

								item.rateNum = null; //当前汇率
								item.position = null; //仓位
								item.currentPrice = (this as any).getTypePrice(item.quote_price, item
									.queuingPrice, item.counterpartyPrice, item.symbol_name, index); //现价
								if (!item.currentPrice) {
									if (!(this as any).curSelectPriceList.includes(item.symbol_name)) {
										(this as any).curSelectPriceList.push(item.symbol_name);
									}
								}
								let exchange_obj = (this as any).exchangeList.find(obj => item
									.exchange_no === obj.exchange_code);
								item.level = exchange_obj.level || null; //0-实时,1-延时
								(this as any).sonTableData.push(item);
							});
							if ((this as any).sonTableData.length >= (this as any).sonTotalNum) {
								(this as any).sonFinished = true;
							};
						}
					})
					.catch(e => {
						Toast.clear();
						// // 
					});
			},
			positionPriceTab(type) {
				(this as any).curSelectPriceList = [];
				(this as any).positionForm.priceType = type;
				if ((this as any).selectAllData.type === type) {
					(this as any).accountAll = JSON.parse(JSON.stringify((this as any).selectAllData.data));
				}
				(this as any).sonTableData.forEach((item, index) => {
					item.currentPrice = (this as any).getTypePrice(item.quote_price, item.queuingPrice, item
						.counterpartyPrice, item.symbol_name, index); //现价
					if (!item.currentPrice) {
						if (!(this as any).curSelectPriceList.includes(item.symbol_name)) {
							(this as any).curSelectPriceList.push(item.symbol_name);
						}
						(this as any).accountAll.forEach((val, j) => {
							if (index === val) {
								(this as any).accountAll.splice(j, 1);
							}
						});
					}
				});
				// (this as any).checkboxChange((this as any).accountAll);
			},
			orderPriceTab(type, num) {
				(this as any).isFocse = false;
				(this as any).sheetForm.priceType = type;
				(this as any).sheetForm.order_price = num;
			},
			async batchQueryBatchorder() {
        // 加个锁 默认false 可以提交
        if((this as any).disSubmit){
          return false;
        }
        (this as any).disSubmit = true; //点击了设置为true 接口响应后为false
				await (this as any).getSonList();
				Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '加载中...',
				});
				const {
					number,
					order_type,
					priceType
				} = (this as any).positionForm;
				let obj = '';
				switch (priceType) {
					case 1:
						obj = 'quote_price'
						break;
					case 2:
						obj = 'queuingPrice'
						break;
					case 3:
						obj = 'counterpartyPrice'
						break;
					default:
						break;
				}
				let num = number;
				let orders = [];
				(this as any).queryTable.forEach(cItem => {
				    let item = (this as any).sonTableData.find(sItem => sItem.symbol == cItem.symbol && sItem.account_no == cItem.account_no);
					let addParams = (this as any).addBatchorderParams(item, true);
					const {
						account_no,
						exchange_no,
						commodity_no,
						contract_no,
						commodity_type,
						match_side,
						quote_price,
						queuingPrice,
						counterpartyPrice,
						can_close_num,
						digits
					}: any = item;
					// const number = Math.ceil(can_close_num/num);
					let number: any = Number(can_close_num / num);
					// if((this as any).queryParem.account ===2){
					number = (this as any).getOrderNumber(item.lot_min, can_close_num, num, item.position_qty);
					// }else{
					//     number = parseInt(number);
					// }
					const order_price = parseFloat(item[obj]);
					const p = {
						account_no: account_no, //客户资金账号
						exchange_no: exchange_no, //交易所编号
						commodity_no: commodity_no, //品种编码类型
						contract_no: contract_no, //合约
						commodity_type: String(commodity_type), //品种类型  默认是70  为期货  84 股票
						order_side: commodity_type === 70 ? String(match_side === 66 ? 83 : 66) :
						'83', //买入卖出 66 买入 83 卖出
						order_type: order_type, //委托类型 49 市价 50 限价 71 港交所竞价市价单 72 港交所竞价限价单
						order_price: order_price ? String(order_price.toFixed(item['digits'])) : null, //  委托价格
						order_qty: String(number), //委托数量
						...addParams
					};
					orders.push(p as never);
				});


				let parmes = {
					order_method: 2,
					orders
				};
				// 
				(this as any).$apis.queryBatchorder(parmes, {
					'X-channel-id': (this as any).queryParem.type
				}).then(res => {
          (this as any).disSubmit = false; //
					let errCode:any = []
					const { error_code,data } = res
					if (data) {
						errCode = data.filter(item => item.error_code !== 0)
					}
					if (error_code === 0 && errCode.length !== 0) {
						Toast.clear();
						Dialog.alert({
							title: `${errCode[0].account_no}(${errCode[0].account_name})`,
							message: `提交失败,${errCode[0].error_msg},请重试`,
							closeOnClickOverlay: true,
							confirmButtonText: '知道了',
						}).then(() => {
							(this as any).isFocse = false;
							(this as any).overlayShow = false;
							(this as any).refreshing = true;
							(this as any).sheetShow = false;
							(this as any).onRefresh();
						});
					}else{
						Toast('订单已提交，请关注订单状态');
						(this as any).isFocse = false;
						(this as any).overlayShow = false;
						(this as any).refreshing = true;
						(this as any).sheetShow = false;
						(this as any).onRefresh();
						setTimeout(() => {
							Toast.clear();
						}, 1500)
					}
				}).catch(() => {
          (this as any).disSubmit = false; //
					Toast.clear()
				})
			},
			// 平仓 新增参数
			addBatchorderParams(item, isBatch = false){
				let  { digits, quote_price, queuingPrice, counterpartyPrice , date_time_stamp = 0, can_close_num, show_symbol } = item;
				let { priceType } = (this as any).sheetForm;
				// 左：页面选中的类型
				// 右：对应要提交的类型
				let keys = {
					0: 0,
					1: 2,
					3: 4,
					2: 3
				};
				let price_type = keys[priceType];
				if((this as any).positionForm.order_type == 49){
					price_type = 1;
				}
				let params = {
					price_type, // 0 手动输入价格 1 市价  2 最新行情价  3 对手价  4 排队价
					order_source: window.location.href,
					quote_detail: {
						last_price: quote_price ? parseFloat(parseFloat(quote_price).toFixed(digits)) : 0, //最新价
						ask_price: queuingPrice ? parseFloat(parseFloat(queuingPrice).toFixed(digits)) : 0, // 买一价
						bid_price: counterpartyPrice ? parseFloat(parseFloat(counterpartyPrice).toFixed(digits)) : 0, // 卖一价
						date_time_stamp: Number(date_time_stamp), // 时间戳
					},
					is_close_order: 1, // 是否平仓单 0 非平仓单 1 平仓
					can_close_qty: String(can_close_num), // app 可平数量
          origin_symbol: show_symbol
				}

				if(isBatch){
					 // 批量平仓才有的字段 平仓百分比 1 0.5 0.25 如果算出是小数  数量相上
					 let isBatchKeys = {
					 	1: 1,
					 	2: 0.5,
					 	4: 0.25
					 };
					params['close_persent'] = isBatchKeys[(this as any).positionForm.number];
				}else{
					if((this as any).mPositionTypeActive != -1 && Math.ceil((this as any).rowPosition.can_close_num * (this as any).mPositionTypeActive) == (this as any).sheetForm.number){
						params['close_persent'] = (this as any).mPositionTypeActive;
					}else{
						params['close_persent'] = -1;
					}
				}
				return params;
			},
			async queryBatchorder() {
        // 加个锁 默认false 可以提交
        if((this as any).disSubmit){
          return false;
        }
        (this as any).disSubmit = true; //点击了设置为true 接口响应后为false
				await (this as any).getList();
				const {
					account_no,
					exchange_no,
					commodity_no,
					contract_no,
					commodity_type,
					match_side,
					lot_min,
					commodity_tick_size,
					digits
				} = (this as any).rowPosition;
				const {
					number,
					checked,
					order_price
				} = (this as any).sheetForm;
				const {
					order_type
				} = (this as any).positionForm;
				let newParams = (this as any).addBatchorderParams((this as any).rowPosition);
				let parmes = {
					order_method: 2,
					orders: [{
						account_no: account_no, //客户资金账号
						exchange_no: exchange_no, //交易所编号
						commodity_no: commodity_no, //品种编码类型
						contract_no: contract_no, //合约
						commodity_type: String(commodity_type), //品种类型  默认是70  为期货  84 股票
						order_side: commodity_type === 70 ? String(match_side === 66 ? 83 : 66) :
						'83', //买入卖出 66 买入 83 卖出
						order_type: order_type, //委托类型 49 市价 50 限价 71 港交所竞价市价单 72 港交所竞价限价单
						order_price: String(order_price), //  委托价格
						order_qty: String(number), //委托数量
						// stop_price:'',  //触发价格
						// trigger_condition:'', // 触发条件   用于条件单  71 大于等于 76 小于等于
						// trigger_price_types:'',  //触发价格类型  用于条件单   66 买价  83 卖价 76 最新价
						addone_isvalid: checked ? '1' : '0', //是否T+1 , 0 否 1 是, 不填为否
						...newParams
					}]
				};
        
        (this as any).disSubmit = false;

				if (parseFloat(number) % parseFloat(lot_min) !== 0) {
					return Toast.fail("请输入正确的数量")
				}
				let price: any = parseFloat(order_price) / (parseFloat(commodity_tick_size))
				// 
				if (Math.round(price) != price.toFixed(2)) {
					return Toast.fail("请输入正确的价格")
				}
				Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '加载中...',
				});
        const noPriceType = ["66", "49", "51", "71"];
        if (noPriceType.includes(order_type)) {
          parmes.orders.forEach(oItem => {
            delete oItem.order_price;
          });
        }
				(this as any).$apis.queryBatchorder(parmes, {
					'X-channel-id': (this as any).queryParem.type
				}).then(res => {
          (this as any).disSubmit = false; // 解锁
					let errCode:any = []
					const { error_code,data } = res
					if (data) {
						errCode = data.filter(item => item.error_code !== 0)
					}
					if (error_code === 0 && errCode.length !== 0) {
						Toast.clear();
						Dialog.alert({
							title: `${errCode[0].account_no}(${errCode[0].account_name})`,
							message: `提交失败,${errCode[0].error_msg},请重试`,
							closeOnClickOverlay: true,
							confirmButtonText: '知道了',
						}).then(() => {
							(this as any).isFocse = false;
							(this as any).refreshing = true;
							// (this as any).sheetShow = false;
							(this as any).onRefresh();
						});
					}else{
						setTimeout(() => {
							Toast.clear();
						}, 1500)
						Toast('订单已提交，请关注订单状态');
						(this as any).isFocse = false;
						(this as any).refreshing = true;
						(this as any).sheetShow = false;
						(this as any).onRefresh();
					}
				}).catch(() => {
          (this as any).disSubmit = false; //
					Toast.clear()
				})
			},
			checkedChange(val) {
				// 
				if ((this as any).sonTableData.length > 1) {
					(this as any).checked = !(this as any).checked;
					if ((this as any).checked) {
						(this as any).$refs.checkboxGroup.toggleAll(true);
						(this as any).selectAllData = {
							type: (this as any).positionForm.priceType,
							data: JSON.parse(JSON.stringify((this as any).accountAll))
						};
						(this as any).curSelectPriceList = [];
						(this as any).sonTableData.forEach((item, index) => {
							if (!item.currentPrice) {
								if (!(this as any).curSelectPriceList.includes(item.symbol_name)) {
									(this as any).curSelectPriceList.push(item.symbol_name);
								}
								(this as any).accountAll.forEach((val, j) => {
									if (index === val) {
										(this as any).accountAll.splice(j, 1);
									}
								});
							}
						});
					} else {
						(this as any).$refs.checkboxGroup.toggleAll(false);
					}
				} else {
					if ((this as any).checked && !(this as any).isChecked) {
						(this as any).$refs.checkboxGroup.toggleAll(true);
						(this as any).$nextTick(() => {
							(this as any).isChecked = true;
						});

						// 
						(this as any).selectAllData = {
							type: (this as any).positionForm.priceType,
							data: JSON.parse(JSON.stringify((this as any).accountAll))
						};
						(this as any).curSelectPriceList = [];
						(this as any).sonTableData.forEach((item, index) => {
							if (!item.currentPrice) {
								if (!(this as any).curSelectPriceList.includes(item.symbol_name)) {
									(this as any).curSelectPriceList.push(item.symbol_name);
								}
								(this as any).accountAll.forEach((val, j) => {
									if (index === val) {
										(this as any).accountAll.splice(j, 1);
									}
								});
							}
						});
						// 
					} else {
						(this as any).isChecked = false;
						(this as any).$refs.checkboxGroup.toggleAll(false);
					}
				}


			},
			checkboxChange(valArr) {
				let val: any = Array.from(new Set(valArr));
				if (val.length - 1 === (this as any).sonTableData.length) {
					(this as any).checked = true;
					(this as any).isHalfSelected = false;
				} else {
					(this as any).checked = false;
					if (val.length) {
						if (val.length === (this as any).sonTableData.length) {
							(this as any).checked = true;
							(this as any).isHalfSelected = false;
						} else {
							(this as any).isHalfSelected = true;
						}

					} else {
						(this as any).isHalfSelected = false;
					}
				};
				let arr = val.filter(item => {
					if ((item || item === 0) && item !== 'all') {
						return item + 1;
					}
				});
				(this as any).queryTable = [];
				(this as any).curSelectList = [];
				// (this as any).curSelectPriceList = [];
				arr.forEach(item => {
					(this as any).queryTable.push((this as any).sonTableData[item]);

					(this as any).noPriceList.forEach(val => {
						// 
						if ((this as any).sonTableData[item].symbol_name === val && !(this as any)
							.curSelectList.includes((this as any).sonTableData[item].symbol_name)) {
							(this as any).curSelectList.push(val);
						}
					});
					// (this as any).noPriceTypeList.forEach(val => {
					//     if(val.index === item && !(this as any).curSelectPriceList.includes((this as any).sonTableData[item].symbol_name)){
					//         (this as any).curSelectPriceList.push(val.symbol_name);
					//     }
					// });
				})
				// (this as any).queryTable.forEach(item => {
				let usa = (this as any).queryTable.find(val => {
					if ((val && val.exchange_no) && ['NASDAQ', 'AMEX', 'NYSE'].includes(val.exchange_no)) {
						return val;
					}
				});
				let hk = (this as any).queryTable.find(item => {
					return item.exchange_no === 'HKSE'
				});

				if (hk && usa) {
					(this as any).marketType = 4;
				} else {
					if (hk) {
						(this as any).marketType = 2;
					} else {
						if (usa) {
							(this as any).marketType = 3;
						}
					}
				}
				// });

				// 
				// 
			},
			closingPosition(row: any = {}) {
        (this as any).marketType = 1;
				let usa = false;
				if (['NASDAQ', 'AMEX', 'NYSE'].includes(row.exchange_no)) {
					usa = true;
				}
				let hk = false;
				if (row.exchange_no === 'HKSE') {
					hk = true;
				}

				if (hk && usa) {
					(this as any).marketType = 4;
				} else {
					if (hk) {
						(this as any).marketType = 2;
					} else {
						if (usa) {
							(this as any).marketType = 3;
						}
					}
				}
        if((this as any).hasAcution.includes(row.commodity_no)){
          (this as any).marketType = 5;
        }

				(this as any).rowPosition = row;
				(this as any).sheetForm.number = row.can_close_num;
				(this as any).sheetForm.order_price = row.quote_price ? row.quote_price.toFixed(row.digits) : '';
				(this as any).adPng = require('@/assets/images/h5Page/add.png');
				(this as any).adPrPng = require('@/assets/images/h5Page/add.png');
				(this as any).priceClick = true;
				if (row.can_close_num > row.lot_min) {
					(this as any).numberClick = true;
					(this as any).delPng = require('@/assets/images/h5Page/del.png');
				}
				(this as any).sheetShow = true;
				(this as any).changeMPositionType(1);
			},
			async getListNew() {
				await (this as any).getList();
        clearTimeout((this as any).timer);
        if(localStorage.getItem('token')){
          (this as any).timer = setTimeout(() => {
            (this as any).getListNew();
          }, 10000);
        }
			},
			async getList() {
				sessionStorage.setItem('xid', (this as any).queryParem.type);
				// Toast.loading({
				//   duration: 0, // 持续展示 toast
				//   forbidClick: true,
				//   message: '加载中...',
				// });
				(this as any).groupColumns = ['全部'];
				await (this as any).$apis
					.querybatchpos({
            ...(this as any).listParem, // 解构一下就可以了？？？？？ 什么鬼
          }, {
						'X-channel-id': (this as any).queryParem.type
					})
					.then(async (respond) => {
						let res = {
							data: respond
						};
						// Toast('刷新成功');
						(this as any).totalNum = res.data.total;
						// res.data.symbol_code_names && res.data.symbol_code_names.forEach(item => {
						//     (this as any).groupColumns.push(item.name)
						// });
						// if(!(this as any).batchGoods){
						//     (this as any).batchGoods = (this as any).groupColumns[0];
						// };

						// (this as any).sonParem.symbol = res.data.symbol_code_names[0].code;
						// (this as any).symbolList = res.data.symbol_code_names;

						let q = res.data?.pos_infos?.map(item => {
							return item.symbol
						}).join(',');
            let tableData: any = [];
            // 
						if (q && (this as any).queryParem.account) {
              let queryParem: any = {
                page_size: 1000,
                current_page: 1,
                account_no: (this as any).queryParem.account
              };
							let qute = (this as any).$apis
								.future_ticksnapshot({
									symbol: q
								});
							let rate = (this as any).$apis
								.getRate({
									symbol: q
								});
							let contractInfote = (this as any).$apis
								.getContractInfo({
									symbol: q,
									isExpired: 2
								});
							let getQryFund = (this as any).$apis
								.querygroupfund(queryParem, {
									'X-channel-id': (this as any).queryParem.type
								});
							if ((this as any).queryParem.type === 1) {
								await Promise.all([qute, rate, contractInfote, getQryFund]).then((result1) => {
									let result = result1.map(item => ({
										data: item
									}));

									Toast.clear();
									// 
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										let symbol = result[0].data.future_ticks.find(val => val
											.symbol === item.symbol);
										item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										let contract_info = result[2].data.contract_info.find(
											val => val.symbol === item.symbol);
										item.contract_size = contract_info.contract_size ||
										null; //合约乘数
										item.commodity_tick_size = contract_info
											.commodity_tick_size || null; //最小变动单位.
										item.lot_min = contract_info.lot_min || null; //最小交易数量.
										item.digits = contract_info.digits || 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (symbol) {
											item.date_time_stamp = symbol.date_time_stamp;
											let fund = result[3].data.fund_infos.find(val => val
												.account_no === item.account_no);
											if(fund){
												// 
												let curRate = result[1].data.currency_rate.find(
												val => {
													if (val.to === fund.currency_no && val
														.from === contract_info.currency_no) {
														return val;
													}
												});
												// 当前汇率取值逻辑如下：
												// 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
												// 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
												let rateNum:any = '';
												if(curRate){
													rateNum = item.match_side == 66 ? curRate.sell :
														curRate.buy;
												}else{
													rateNum = 1
												}
												// 仓位 : match_side == 66 ?  position_qty : -position_qty
												let position = item.match_side == 66 ? item
													.position_qty : -item.position_qty;

												// (this as any).contract_info_msg = contract_info
												// (this as any).curRateMsg = curRate

												// 


												item.quote_price = symbol.last_price || symbol
													.pre_closing_price || symbol.pre_settle_price;
												//当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
												// // 
												// // 
												item.profitLoss = +(((item.quote_price - item
														.position_price) * position * rateNum *
													contract_info.contract_size).toFixed(2));
												// 浮动盈亏 / 成本）* 100%
												item.profitLossRate = item.cost ? (item.profitLoss /
													item.cost) * 100 : 100;

												if (item.match_side === 66) {
													item.counterpartyPrice = symbol.bid_price[0] &&
														symbol.bid_price[0].toFixed(2);
													item.queuingPrice = symbol.ask_price[0] && symbol
														.ask_price[0].toFixed(2);
												} else if (item.match_side === 83) {
													item.queuingPrice = symbol.bid_price[0] && symbol
														.bid_price[0].toFixed(2);
													item.counterpartyPrice = symbol.ask_price[0] &&
														symbol.ask_price[0].toFixed(2);
												}
												item.rateNum = rateNum;
												item.position = position;
												// item.contract_size = contract_info.contract_size;
											}
										} else {
											let fund = result[3].data.fund_infos.find(val => val
												.account_no === item.account_no);
											if(fund){
												// 
												let curRate = result[1].data.currency_rate.find(
												val => {
													if (val.to === fund.currency_no && val
														.from === contract_info.currency_no) {
														return val;
													}
												});
												// 当前汇率取值逻辑如下：
												// 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
												// 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
												let rateNum:any = '';
												if(curRate){
													rateNum = item.match_side == 66 ? curRate.sell :
														curRate.buy;
												}else{
													rateNum = 1
												}


												// let rateNum = item.match_side == 66 ? curRate.sell :
												// 	curRate.buy;
												// 仓位 : match_side == 66 ?  position_qty : -position_qty
												let position = item.match_side == 66 ? item
													.position_qty : -item.position_qty;

												//当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
												// // 
												// // 
												item.profitLoss = +(((item.quote_price - item
														.position_price) * position * rateNum *
													contract_info.contract_size).toFixed(2));
												// 浮动盈亏 / 成本）* 100%
												item.profitLossRate = item.cost ? (item.profitLoss /
													item.cost) * 100 : 100;

												item.rateNum = rateNum;
												item.position = position;
											}
										}
										if (index >= 0) {
											let obj = JSON.parse(JSON.stringify(item));
											obj.isgo = true;
											tableData.push(item, obj)
										} else {
											tableData.push(item);
										}
										// 
										// (this as any).initTableData.push(item);

										if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) != '{}') {
											if ((this as any).rowPosition.symbol == item.symbol && item.account_no == (this as any).rowPosition.account_no) {
												if((this as any).mPositionTypeActive != -1 && Math.ceil((this as any).rowPosition.can_close_num * (this as any).mPositionTypeActive) == (this as any).sheetForm.number){
													// (this as any).sheetForm.number = item.can_close_num
													(this as any).rowPosition = item;
													(this as any).changeMPositionType((this as any).mPositionTypeActive);
												}else{

													(this as any).rowPosition = item;
												}
												// if ((this as any).sheetForm.priceType === 1) {
												// 	(this as any).sheetForm.order_price = (this as any).rowPosition.quote_price.toFixed(item
												// 		.digits)
												// } else if ((this as any).sheetForm.priceType === 3) {
												// 	(this as any).sheetForm.order_price = item.queuingPrice.toFixed(item
												// 		.digits)
												// } else if ((this as any).sheetForm.priceType === 2) {
												// 	(this as any).sheetForm.order_price = item.counterpartyPrice.toFixed(
												// 		item.digits)
												// }
												(this as any).orderPrice(item);
											}
										}
									});
                  (this as any).tableData = tableData;
									if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) != '{}') {
										let { symbol, account_no } = (this as any).rowPosition;
										let _rowIndex = res?.data?.pos_infos?.find(item => item.symbol == symbol && item.account_no == account_no);
                    // 
										if(!_rowIndex || _rowIndex < 0){
											(this as any).rowPosition.can_close_num = 0;
										}
									}
									// 
									// 
									if ((this as any).tableData.length >= (this as any).totalNum) {
										(this as any).finished = true;
									}
									(this as any).getSocketList()
									// result = null;
								}).catch(err => {
									// 
									(this as any).tableData = [];
									Toast.clear();
									// Toast('接口请求失败');
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										item.contract_size = null; //合约乘数
										item.commodity_tick_size = null; //最小变动单位.
										item.lot_min = null; //最小交易数量.
										item.digits = 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (index >= 0) {
											let obj = JSON.parse(JSON.stringify(item));
											obj.isgo = true;
											tableData.push(item, obj)
											obj = null;
										} else {
											tableData.push(item);
										}
										// (this as any).initTableData.push(item);

										if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) !=
											'{}') {
											if ((this as any).rowPosition.symbol == item.symbol && (this as any).rowPosition.account_no == item.account_no) {
												(this as any).rowPosition = item;
											}
										}
									});
                  (this as any).tableData = tableData;
									if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) != '{}') {
										let { account_no, symbol } = (this as any).rowPosition;
										let _rowIndex = res?.data?.pos_infos?.find(item => item.symbol == symbol && item.account_no == account_no);
										if(!_rowIndex || _rowIndex < 0){
											(this as any).rowPosition.can_close_num = 0;
										}
									}
									// if ((this as any).initTableData.length >= (this as any).totalNum) {
										(this as any).finished = true;
									// }
									(this as any).getSocketList();
								});
							} else if ((this as any).queryParem.type === 2) {
								// 持仓盈亏（股票）=  （最新价 - 持仓价position_price）* 股数position_qty
								await Promise.all([qute, contractInfote]).then((result1) => {
									let result:any = result1.map(item => ({
										data: item
									}));

									(this as any).tableData = [];

									Toast.clear();
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										let symbol = result[0].data.future_ticks.find(val => val
											.symbol === item.symbol);
										item.quote_price = item.calculate_price;
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null;
										// item.queuingPrice = null;

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										let contract_info = result[1].data.contract_info.find(
											val => val.symbol === item.symbol);
										item.contract_size = contract_info.contract_size ||
										null; //合约乘数
										item.commodity_tick_size = contract_info
											.commodity_tick_size || null; //最小变动单位.
										item.lot_min = contract_info.lot_min || null; //最小交易数量.
										item.digits = contract_info.digits || 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (symbol) {
											item.date_time_stamp = symbol.date_time_stamp;
											item.quote_price = symbol.last_price || symbol
												.pre_closing_price || symbol.pre_settle_price;
											item.profitLoss = +(((item.quote_price - item
													.position_price) * item.position_qty)
												.toFixed(2));
											//证券成本 = 持仓价 * 持仓量position_qty * 合约乘数contract_size * 100%
											let cost = item.position_price * item.position_qty *
												contract_info.contract_size;
											// 浮动盈亏 / 成本）* 100%
											item.profitLossRate = cost ? (item.profitLoss / cost) *
												100 : 100;
											if (item.match_side === 66) {
												item.counterpartyPrice = symbol.bid_price[0] &&
													symbol.bid_price[0].toFixed(2);
												item.queuingPrice = symbol.ask_price[0] && symbol
													.ask_price[0].toFixed(2);
											} else if (item.match_side === 83) {
												item.queuingPrice = symbol.bid_price[0] && symbol
													.bid_price[0].toFixed(2);
												item.counterpartyPrice = symbol.ask_price[0] &&
													symbol.ask_price[0].toFixed(2);
											}
											item.cost = cost; //成本
											// item.contract_size = contract_info.contract_size;
										} else {
											item.profitLoss = +(((item.quote_price - item
													.position_price) * item.position_qty)
												.toFixed(2));
											//证券成本 = 持仓价 * 持仓量position_qty * 合约乘数contract_size * 100%
											let cost = item.position_price * item.position_qty *
												contract_info.contract_size;
											// 浮动盈亏 / 成本）* 100%
											item.profitLossRate = cost ? (item.profitLoss / cost) *
												100 : 100;
											item.cost = cost; //成本
										}
										if (index >= 0) {
											let obj = JSON.parse(JSON.stringify(item));
											obj.isgo = true;
											tableData.push(item, obj)
										} else {
											tableData.push(item);
										}
										// (this as any).initTableData.push(item);
										if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) !=
											'{}') {
											if ((this as any).rowPosition.symbol == item.symbol && (this as any).rowPosition.account_no == item.account_no) {
												(this as any).rowPosition = item;
												// if ((this as any).sheetForm.priceType === 1) {
												// 	(this as any).sheetForm.order_price = (this as any).rowPosition.quote_price.toFixed(item
												// 		.digits)
												// } else if ((this as any).sheetForm.priceType === 3) {
												// 	(this as any).sheetForm.order_price = item.queuingPrice.toFixed(item
												// 		.digits)
												// } else if ((this as any).sheetForm.priceType === 2) {
												// 	(this as any).sheetForm.order_price = item.counterpartyPrice.toFixed(
												// 		item.digits)
												// }
												(this as any).orderPrice(item)
											}
										}
									});
                  (this as any).tableData = tableData;
									if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) != '{}') {
										let { account_no, symbol } = (this as any).rowPosition;
										let _rowIndex = res?.data?.pos_infos?.find(item => item.symbol == symbol && item.account_no == account_no);
										if(!_rowIndex || _rowIndex < 0){
											(this as any).rowPosition.can_close_num = 0;
										}
									}
									// if ((this as any).initTableData.length >= (this as any).totalNum) {
										(this as any).finished = true;
									// }
									(this as any).getSocketList()
									// result = null;
								}).catch(err => {
									Toast.clear();
									// Toast('接口请求失败');
									res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
										item.isgo = false;
										item.quote_price = item.calculate_price; //最新价
										item.profitLoss = null;
										item.profitLossRate = null;
										// item.counterpartyPrice = null; //对手价
										// item.queuingPrice = null; //排队价

										item.rateNum = null; //当前汇率
										item.position = null; //仓位
										item.contract_size = null; //合约乘数
										item.commodity_tick_size = null; //最小变动单位.
										item.lot_min = null; //最小交易数量.
										item.digits = 0; //小数位.
										let exchange_obj = (this as any).exchangeList.find(obj =>
											item.exchange_no === obj.exchange_code);
										item.level = exchange_obj.level || null; //0-实时,1-延时
										if (index >= 0) {
											let obj = JSON.parse(JSON.stringify(item));
											obj.isgo = true;
											tableData.push(item, obj)
										} else {
											tableData.push(item);
										}
										// (this as any).initTableData.push(item);

									});
                  (this as any).tableData = tableData;
									// if ((this as any).initTableData.length >= (this as any).totalNum) {
										(this as any).finished = true;
									// }
								});
							}
							qute = null;
							rate = null;
							contractInfote = null;
							getQryFund = null;
							queryParem = null;
						} else {

							Toast.clear();
							res.data.pos_infos && res.data.pos_infos.forEach((item, index) => {
								item.isgo = false;
								item.quote_price = item.calculate_price; //最新价
								item.profitLoss = null;
								item.profitLossRate = null;
								// item.counterpartyPrice = null; //对手价
								// item.queuingPrice = null; //排队价

								item.rateNum = null; //当前汇率
								item.position = null; //仓位
								item.contract_size = null; //合约乘数
								item.commodity_tick_size = null; //最小变动单位.
								item.lot_min = null; //最小交易数量.
								item.digits = 0; //小数位.
								let exchange_obj = (this as any).exchangeList.find(obj => item
									.exchange_no === obj.exchange_code);
								item.level = exchange_obj.level || null; //0-实时,1-延时
								if (index >= 0) {
									let obj = JSON.parse(JSON.stringify(item));
									obj.isgo = true;
									tableData.push(item, obj)
								} else {
									tableData.push(item);
								}
								// (this as any).initTableData.push(item);

							});
              (this as any).tableData = tableData;
              if ((this as any).rowPosition && JSON.stringify((this as any).rowPosition) != '{}') {
                let { symbol, account_no } = (this as any).rowPosition;
                let _rowIndex = res?.data?.pos_infos?.find(item => item.symbol == symbol && item.account_no == account_no);
                if(!_rowIndex || _rowIndex < 0){
                  (this as any).rowPosition.can_close_num = 0;
                }
              }
							// if ((this as any).initTableData.length >= (this as any).totalNum) {
								(this as any).finished = true;
							// }
						}
						q = null;


						// res.data.pos_infos && res.data.pos_infos.forEach(item => {
						//     item.isgo = false;
						//     if(item.position_price > 0){
						//         let obj = JSON.parse(JSON.stringify(item));
						//         obj.isgo = true;
						//         (this as any).tableData.push(item,obj)
						//     }else{
						//         (this as any).tableData.push(item);
						//     }
						//     (this as any).initTableData.push(item);
						// });

						// // 
						// (this as any).tableData.forEach(item => {
						//     debugger
						// });
						// // 
						// if ((this as any).initTableData.length >= (this as any).totalNum) {
						//     (this as any).finished = true;
						// }
						// (this as any).getSocketList()
					})
					.catch(e => {
						Toast.clear();
						// 
					});
			},
			onLoad() {
				// const box: any = document.getElementById("app");
				// if (box.scrollTo) {
				//   box.scrollTo(0, 250)
				// } else {
				//   box.scrollTop = 0
				// }
				// setTimeout(() => {
					if ((this as any).refreshing) {
						(this as any).finished = false;
						(this as any).listParem.page = 0;
						(this as any).totalNum = 0;
						(this as any).tableData = [];
						(this as any).refreshing = false;
						// (this as any).initTableData = [];
						(this as any).accountAll = [];
					}
					(this as any).loading = true;
					// (this as any).listParem.page++;
					(this as any).getListNew();
					(this as any).loading = false;
					(this as any).refreshing = false;
				// }, 1000);
			},
			onRefresh() {
				// clearTimeout((this as any).onRefreshTimer);
				// (this as any).onRefreshTimer = setTimeout(() => {
					// 重新加载数据
					// 将 loading 设置为 true，表示处于加载状态
					(this as any).loading = true;
					(this as any).onLoad();
				// }, 1000);
			},
			orderPrice(item){
				if ((this as any).sheetForm.priceType === 1) {
					(this as any).sheetForm.order_price =  parseFloat((this as any).rowPosition.quote_price).toFixed(item.digits)
				} else if ((this as any).sheetForm.priceType === 3 && item.match_side === 83) {
				  (this as any).sheetForm.order_price = parseFloat(item.counterpartyPrice).toFixed(item.digits)
				} else if ((this as any).sheetForm.priceType === 2 && item.match_side === 83) {
				  (this as any).sheetForm.order_price = parseFloat(item.queuingPrice).toFixed(item.digits)
				} else if ((this as any).sheetForm.priceType === 3 && item.match_side === 66) {
				  (this as any).sheetForm.order_price = parseFloat(item.queuingPrice).toFixed(item.digits)
				} else if ((this as any).sheetForm.priceType === 2 && item.match_side === 66) {
				  (this as any).sheetForm.order_price = parseFloat(item.counterpartyPrice).toFixed(item.digits)
				}
			},
      WSReportInterFn(agentData = "", data){
        const _this = (this as any);
        if (!_this.lastSendData) {
          _this.lastSendData = agentData ? agentData : _this.lastSendData;
        }
        _this.WSReportInter = setTimeout(() => {
          const times = String(new Date());
          try {
            Sentry.captureMessage("websocket_tick_error", {
              level: "info",
              extra: {
                type: "websocket_tick_error",
                lastSendData: _this.lastSendData,
                msg: !data ? "一次都没推。" : `推送了，但是${(window as any).$config.WS_CHECK_TICK_TIME}毫秒后，没推了。`,
                lastData: JSON.stringify(data),
                url: (this as any).wsUrl,
                times,
                WS_CHECK_TICK_TIME: (window as any).$config.WS_CHECK_TICK_TIME
              }
            });
          } catch (err) {
            
          }
          // 递归处理轮询
          _this.WSReportInterFn(agentData, data);
        }, (window as any).$config.WS_CHECK_TICK_TIME);
      },
			// socket变动
			getSocketList(wsUrl) {
        // if(!wsUrl){
        //   wsUrl = (window as any).$config.VUE_APP_SOCKET_URL;
        // }
        // (this as any).wsUrl = wsUrl;
        let symbol = '';
        (this as any).tableData.forEach(item => {
          symbol += item.symbol + ','
        });
        let struct: any = {
          MsgType: 'SubTicks',
          MsgBody: {
            symbol: symbol
          }
        };

        (this as any).$socket.sendMsg(struct);

        // 开启订单信息监听
        let _this = (this as any);
        if(_this.queryParem.account){
          (this as any).socketTransaction(_this.queryParem.account);
        }
      },
      // 订单信息监听 回调
      mySocketOnMsg(msg) {
        const _this = (this as any);
        if (_this.activeTab == 0) {
          _this.getListNew();
          if (_this.overlayShow) {
            _this.getSonListNew();
          }
        }
      },

			onSonConfirm(value, index) {
				(this as any).$refs.checkboxGroup.toggleAll(false);
				(this as any).$nextTick(()=>{
					(this as any).queryTable = [];
					(this as any).curSelectList = [];
					(this as any).accountAll = [];
					(this as any).popupShow = false;
					(this as any).batchGoods = (this as any).groupColumns[index];
					if (index === 0) {
						(this as any).sonParem.symbol = '';
					} else {
						(this as any).sonParem.symbol = (this as any).symbolList[index - 1].code;
					}
					(this as any).openSon();
				})
			},
			onSonChange(picker, value, index) {},
			onSonCancel() {
				(this as any).popupShow = false
			},
			onTypeConfirm(value, index) {
				(this as any).typePopupShow = false;
				(this as any).curOrderType = value;
				let usa = false;
				if (['NASDAQ', 'AMEX', 'NYSE'].includes((this as any).rowPosition.exchange_no)) {
					usa = true;
				}
				let hk = false;
				if ((this as any).rowPosition.exchange_no === 'HKSE') {
					hk = true;
				}

				if (hk && usa) {
					(this as any).marketType = 4;
				} else {
					if (hk && ['市价单', '竞价市价单'].includes(value)) {
						(this as any).curOrderIndex = false;
					} else if (usa && ['市价单', '竞价市价单'].includes(value)) {
						(this as any).curOrderIndex = false;
					} else {
						(this as any).curOrderIndex = true;
					}
				}
				(this as any).positionForm.order_type = (this as any).typeValue[index];
			},
			onTypeCancel() {
				(this as any).typePopupShow = false
			},
			notifyNewOrder() {
				(this as any).refreshing = true;
				(this as any).onRefresh();
			},
      /**
       * @Description PC端兼容滑动 tableMouseDown、tableMouseMove、tableMouseUp、allTableMouseMove、allTableMouseUp、allTableMouseLeave
       * @date 2024/1/8
       * @param
       * @return {void}
       */
      tableMouseDown(e,mouseObj,refStr){
        let _this = (this as any);
        mouseObj.isDragging = true;
        mouseObj.startX = e.clientX;
        mouseObj.startScrollLeft = _this.$refs[refStr].scrollLeft;
      },
      tableMouseMove(e,mouseObj,refStr){
        let _this = (this as any);
        if (mouseObj.isDragging) {
          const deltaX = e.clientX - mouseObj.startX;
          _this.$refs[refStr].scrollLeft = mouseObj.startScrollLeft - deltaX;
        }
      },
      tableMouseUp(e,mouseObj){
        mouseObj.isDragging = false;
      },
      allTableMouseMove(e){
        let _this = (this as any);
        _this.tableMouseMove(e,_this.tableMouseObj,'tableList');
        _this.tableMouseMove(e,_this.sonTableMouseObj,'sonTableList');
      },
      allTableMouseUp(e){
        let _this = (this as any);
        _this.tableMouseUp(e,_this.tableMouseObj);
        _this.tableMouseUp(e,_this.sonTableMouseObj);
      },
      allTableMouseLeave(e){
        let _this = (this as any);
        _this.tableMouseUp(e,_this.tableMouseObj);
        _this.tableMouseUp(e,_this.sonTableMouseObj);
      }
		},
    destroyed() {
      (this as any).isLockWs = true;
      clearTimeout((this as any).timer)
      clearTimeout((this as any).sonTimer);
      (window as any).removeEventListener('visibilitychange', (this as any).visibilityFn);
    }
  };
